export type Point = {
  x: number
  y: number
}

export enum DragType {
  FREE = 'free',
  MAGNETIC = 'magnetic',
}

export type DragInitParams = {
  from?: Point
  to?: Point
  delta?: Point
  deltaAbs?: Point
}

export type DragHandlerParams = {
  element: HTMLElement
  toPosition: { x: number; y: number }
  padding?: Position
  animation?: string
}

export interface MoveService {
  onDragMove: (params: DragMoveParams) => Position
  onDragEnd: (params: DragEndParams) => Position
  calculateElementNewPosition: (params: Omit<DragEndParams, 'animation'>) => Position
}

export type DragAnimation = `${DragType}`

export type Position = { top?: number; right?: number; bottom?: number; left?: number }

export type DragMoveParams = { element: HTMLElement; toPosition: Point }
export type DragEndParams = {
  element: HTMLElement
  toPosition: Point
  padding?: Position
  animation?: string
}
